import React from 'react';
import { CardImg } from "reactstrap";

import styles from './styles.css';

import APIhelper from '../APIhelper';
import { didDeeplinkSku } from '../../LifecycleHooks.js';

import { Carousel } from '../carousel';
import { ProductSKUCard } from '../productSkuCard';
import { ProductDetail } from '../productDetail';
import { Shade } from '../shade';
import { SKU } from '../sku';

import { reStyleCategory, searchAPIPageSize } from '../../config.js';
import classnames from 'classnames';
import Arrow from '../icons/arrow';
import Info from "../icons/info";

export class Products extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedProduct: [],
            shades: [],
            skus: [],
            categories: [],
            products: [],
            itemsLeft: 3,
            selectedCategory: ''
        };

        // this.getCarouselCurrentStep = this.getCarouselCurrentStep.bind(this);
        // this.getCarouselCurrentStepShade = this.getCarouselCurrentStepShade.bind(this);
        this.selectProduct = this.selectProduct.bind(this);
        this.selectSKU = this.selectSKU.bind(this);
        this.selectShade = this.selectShade.bind(this);
        this.handleSelectedRegions = this.handleSelectedRegions.bind(this);
        this.handleSelectedProduct = this.handleSelectedProduct.bind(this);
        this.handleSelectedSKU = this.handleSelectedSKU.bind(this);
        this.handleSelectedShade = this.handleSelectedShade.bind(this);
        this.removeProducts = this.removeProducts.bind(this);
        this.getSlideChangeStepProduct = this.getSlideChangeStepProduct.bind(this);
        this.getSlideChangeStepShade = this.getSlideChangeStepShade.bind(this);
        this.goBackArrow = this.goBackArrow.bind(this);
        this.fetchProduct = this.fetchProduct.bind(this);
        this.retry = this.retry.bind(this);
        this.productsComp = React.createRef();
    };

    processCategories(categories) {

    }

    componentDidMount() {
        let hasCategories = false;
        if (this.props.categories) {
            hasCategories = true;
        }
        const nextState = {};
        let promises = [];
        if (!hasCategories) {
            promises.push(APIhelper.fetchConfigs());
        }
        const deepLink = this.props.activateProduct && (this.props.activateProduct.sku || this.props.activateProduct.productId);
        if (deepLink) {
            if (this.props.activateProduct.sku) {
                didDeeplinkSku(this.props.activateProduct.sku);
            }

            promises.push(APIhelper.fetchByProdSku(this.props.activateProduct.productId, this.props.activateProduct.sku));
        } else {
            promises.push(APIhelper.fetchProducts(1, hasCategories ? this.props.categories.find(c => c.name === this.props.selectedCategory).regions : [], '', 0));
        }
        Promise.all(promises)
            .then((responses) => {// fetch categories and product details
                nextState.categories = hasCategories ? this.props.categories : responses[0].categories;
                const productResponseObj = responses[hasCategories ? 0 : 1];
                let categoryActiveTab = '';
                if (productResponseObj && productResponseObj.data) {
                    nextState.apiSeed = productResponseObj.meta.seed;
                    const product = productResponseObj.data[0];
                    if (product) {
                        const palette = product.palettes.find(pal => pal.sku == this.props.activateProduct.sku);
                        let region, productId, sku;
                        if (palette) {
                            region = palette.tones[0].regions[0]; productId = product.productId; sku = palette.sku;
                        } else {
                            region = product.palettes[0].tones[0].regions[0]; productId = product.productId;
                        }
                        const category = nextState.categories.find((cat) => cat.regions.indexOf(region) >= 0);
                        nextState.productDetailToShow = { category, region, productId, sku, deepLink };
                        categoryActiveTab = nextState.productDetailToShow.category;
                    }
                }
                this.props.setCategories(nextState.categories, categoryActiveTab);
            })
            .then(() => { // fetch all products
                nextState.infoPerCat = {};
                nextState.page = 1;

                promises = [];
                for (let q = 0; q < nextState.categories.length; q++) {
                    promises.push(this.retry(this.fetchProduct.bind(this, nextState, q)));
                }
                return Promise.all(promises)
            })
            .then(((fetchProductsResponses) => { // set category/product/shade to show
                // console.log(fetchProductsResponses);
                try {
                    let selectedCategory = hasCategories ? nextState.categories.find(c => c.name === this.props.selectedCategory) : nextState.categories[1];
                    if (nextState.productDetailToShow) {
                        selectedCategory = nextState.productDetailToShow.category;
                        const fetchResponse = fetchProductsResponses.find(resp => {
                            for (let q = 0; q < nextState.productDetailToShow.category.regions.length; q++) {
                                const region = nextState.productDetailToShow.category.regions[q];
                                if (resp.data[0].palettes[0].tones[0].regions.indexOf(region) >= 0) {
                                    return true;
                                }
                            }
                            return false;
                        });
                        if (fetchResponse) {
                            let productIndex = -1, skuIndex = -1, shadeIndex = -1;
                            if (nextState.productDetailToShow.sku) {
                                productIndex = fetchResponse.data.findIndex(prod => prod.palettes.find(pal => pal.sku == nextState.productDetailToShow.sku));
                                skuIndex = fetchResponse.data[productIndex].palettes.findIndex(pal => pal.sku == nextState.productDetailToShow.sku);
                                shadeIndex = 0;

                                const productApplied = fetchResponse.data[productIndex];
                                const skuApplied = productApplied.palettes[skuIndex];
                                const shadeApplied = skuApplied.tones[shadeIndex];

                                nextState.infoPerCat[nextState.productDetailToShow.category.name].productActiveIndex = productIndex;
                                nextState.infoPerCat[nextState.productDetailToShow.category.name].productIdApplied = fetchResponse.data[productIndex].productId;
                                nextState.infoPerCat[nextState.productDetailToShow.category.name].productIdSelected = fetchResponse.data[productIndex].productId;
                                nextState.infoPerCat[nextState.productDetailToShow.category.name].skuActiveIndex = skuIndex;
                                nextState.infoPerCat[nextState.productDetailToShow.category.name].skuApplied = nextState.productDetailToShow.sku;
                                nextState.infoPerCat[nextState.productDetailToShow.category.name].shadeActiveIndex = shadeIndex;
                                nextState.infoPerCat[nextState.productDetailToShow.category.name].shadeApplied = shadeApplied;
                                nextState.categoryTab = nextState.productDetailToShow.category.name;

                                const activeShade = this.setActiveShade(productApplied, skuApplied, shadeApplied);
                                this.props.activeProduct(activeShade);
                            } else if (nextState.productDetailToShow.productId) {
                                productIndex = fetchResponse.data.findIndex(prod => prod.productId == nextState.productDetailToShow.productId);

                                nextState.infoPerCat[nextState.productDetailToShow.category.name].productActiveIndex = productIndex;
                                nextState.infoPerCat[nextState.productDetailToShow.category.name].productIdApplied = fetchResponse.data[productIndex].productId;
                                nextState.infoPerCat[nextState.productDetailToShow.category.name].productIdSelected = fetchResponse.data[productIndex].productId;
                                nextState.categoryTab = nextState.productDetailToShow.category.name;
                            }
                        }
                    }

                    if (this.state.selectedCategory !== reStyleCategory) {
                        this.setState(nextState);
                        this.handleSelectedRegions(selectedCategory);
                    }
                } catch (error) {
                    throw error;
                }
            }).bind(this))
        // .catch(err => {
        //     throw err;
        // })
    };

    TRIES = {};

    retry(fn, tries = 3) {
        const that = this;
        return fn()
            .then(resp => {
                // console.log('# retry ok ', resp)
                return resp;
            }, (err) => {
                if (tries < 1) {
                    // console.log('# retry throw', err);
                    throw err;
                } else {
                    // console.log('# retry error', err);
                    return that.retry(fn, tries - 1);
                }
            })
    }

    getSkusToShowFirst(productDetailToShow, categoryName) {
        let skusToShowFirst = null;
        if (productDetailToShow &&
            productDetailToShow.deepLink &&
            categoryName == productDetailToShow.category.name) {
            skusToShowFirst = [productDetailToShow.sku]
        }
        return skusToShowFirst;
    }

    fetchProduct(nextState, q, tries) {
        const that = this;
        return new Promise(function (resolve, reject) {
            nextState.infoPerCat[nextState.categories[q].name] = {
                regions: nextState.categories[q].regions,
                productActiveIndex: 0,
                skuActiveIndex: 0,
                shadeActiveIndex: 0,
            };

            // if(!that.TRIES[nextState.categories[q].name]){
            //     that.TRIES[nextState.categories[q].name] = 4;
            // }
            // that.TRIES[nextState.categories[q].name] = that.TRIES[nextState.categories[q].name] - 1;
            // const aux = that.TRIES[nextState.categories[q].name] < 2 ? '' : '4';

            APIhelper.fetchProducts(nextState.page,
                nextState.infoPerCat[nextState.categories[q].name].regions,
                nextState.apiSeed,
                null,
                that.getSkusToShowFirst(nextState.productDetailToShow, nextState.categories[q].name))
                .then((response) => {
                    nextState.infoPerCat[nextState.categories[q].name].seed = nextState.apiSeed;
                    nextState.infoPerCat[nextState.categories[q].name].pagination = response.pagination;
                    // return response;
                    // console.log('# resolve', response);
                    resolve(response);
                    return;
                })
                .catch(reject)
        })
    }

    componentWillUnmount() {
    }

    removeProducts(categories) {
        for (const cat of categories) {
            const infoPerCat = this.state.infoPerCat[cat];
            if (infoPerCat.productIdApplied) {
                infoPerCat.productIdSelected = infoPerCat.productIdApplied;
            }
            if (infoPerCat.skuApplied) {
                infoPerCat.skuActiveSelected = infoPerCat.skuApplied;
            }
            infoPerCat.productIdApplied = '';
            // infoPerCat.productIdSelected = '';
            infoPerCat.skuApplied = '';
            // infoPerCat.skuActiveSelected = '';
            infoPerCat.shadeApplied = null;
        }

        const setActiveProductResponse = this.setActiveProduct(this.state.products,
            this.state.infoPerCat[this.state.categorySelected].productIdSelected,
            this.state.infoPerCat[this.state.categorySelected].skuActiveSelected,
            this.state.infoPerCat[this.state.categorySelected].shadeApplied);

        let nextState = {
            products: setActiveProductResponse.prods,
            showSKUDetail: setActiveProductResponse.skuSelected ? true : false,
            infoPerCat: this.state.infoPerCat,
            activeShade: this.setActiveShade(
                setActiveProductResponse.prodSelected,
                setActiveProductResponse.skuSelected,
                setActiveProductResponse.shadeSelected),
        };

        return nextState;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.clearAll != prevProps.clearAll) {
            const nextState = this.removeProducts(Object.keys(this.state.infoPerCat));
            this.setState(nextState);
        }
        this.props.menuHeightChanged(this.productsComp.current.offsetHeight);
    }

    setSkus = (skus) => {
        // return skus;
        if (skus.find(sku => sku.tones.length > 1)) {
            return skus;
        } else {
            return [];
        }
    }

    handlePagination = (next) => {
        this.props.page(next);
    };

    setActiveShade = (selectedProduct, skuSelected, activeShade) => {
        if (selectedProduct && skuSelected) {
            const objArr = [selectedProduct, skuSelected];
            if (activeShade) objArr.push(activeShade);
            const auxObj = {};
            for (const obj of objArr) {
                for (const key of Object.keys(obj)) {
                    auxObj[key] = obj[key];
                }
            }
            if (!activeShade && selectedProduct.palettes.find(pal => pal.tones.length == 1)) {
                delete auxObj.paletteName;
            }
            return auxObj;
        } else {
            return null;
        }
    }

    setShades = (sku, skus) => {
        if (!skus || skus.find(sku => sku.tones.length > 1)) {
            return sku.tones.map(t => {
                t.sku = sku.sku;
                return t;
            });
        } else {
            return skus.reduce((acc, curr) => {
                return acc.concat(curr.tones.map(t => {
                    t.sku = curr.sku;
                    return t;
                }));
            }, []);
        }
    }

    selectProduct = (activeProduct, nextState) => {

        nextState = nextState || this.state;

        const shadeToActivate = nextState.infoPerCat[nextState.categorySelected].skuApplied ==
            nextState.infoPerCat[nextState.categorySelected].skuActiveSelected ?
            nextState.infoPerCat[nextState.categorySelected].shadeApplied : null;

        const setActiveProductResponse = this.setActiveProduct(nextState.products,
            activeProduct.productId,
            nextState.infoPerCat[nextState.categorySelected].skuApplied || nextState.infoPerCat[nextState.categorySelected].skuActiveSelected,
            shadeToActivate);

        nextState.infoPerCat[nextState.categorySelected].productIdSelected = setActiveProductResponse.prodSelected.productId;
        nextState.infoPerCat[nextState.categorySelected].productActiveIndexSelected = nextState.infoPerCat[nextState.categorySelected].productActiveIndex;

        nextState.setActiveProductResponse = setActiveProductResponse;
        nextState.products = setActiveProductResponse.prods;
        nextState.selectedProduct = setActiveProductResponse.prodSelected;
        nextState.skus = this.setSkus(setActiveProductResponse.prodSelected.palettes);
        nextState.shades = setActiveProductResponse.skuSelected ? this.setShades(setActiveProductResponse.skuSelected, setActiveProductResponse.prodSelected.palettes) : [];
        nextState.activeShade = this.setActiveShade(
            setActiveProductResponse.prodSelected,
            setActiveProductResponse.skuSelected,
            setActiveProductResponse.shadeSelected);
        nextState.hideProdFamily = true;
        nextState.showSKUDetail = setActiveProductResponse.skuSelected ? true : false;
        nextState.infoPerCat = nextState.infoPerCat;
        nextState.carouselStepProduct = setActiveProductResponse.prodSelectedIndex + Math.random();
        nextState.carouselStepSku = (setActiveProductResponse.skuSelectedIndex || 0) + Math.random();
        nextState.carouselStepShade = (setActiveProductResponse.shadeSelectedIndex || 0) + Math.random();

        if (activeProduct) {
            window.utag && utag.link({
                tealium_event: "view_detail",
                page_type: "marketing",
                page_group: "glamlab",
                page_name: "glamlab:try on",
                glamlab_product_category: nextState.categorySelected,
                glamlab_virtual_tryon_mode: localStorage.getItem("mode"), // e.g. photo, model,
                product_id: [activeProduct.productId],
                product_sku: [nextState.activeShade ? nextState.activeShade.sku : ""],
                product_name: [activeProduct.productName],
                product_brand: [activeProduct.productBrand],
            })
        }
        return nextState;
    }

    handleSelectedProduct = (activeProduct) => {

        let nextState = this.selectProduct(activeProduct, this.state);
        nextState = this.selectSKU(null, null, nextState);

        this.setState(nextState);
        if (nextState.activeShade) {
            this.props.activeProduct(nextState.activeShade);
        }
    };

    selectSKU = (sku, index, nextState) => {

        nextState = nextState || this.state;
        if ((!sku || typeof index != 'number') && nextState.setActiveProductResponse) {
            if (nextState.setActiveProductResponse.skuSelected) {
                sku = nextState.setActiveProductResponse.skuSelected;
                index = nextState.setActiveProductResponse.skuSelectedIndex;
            } else {
                sku = nextState.setActiveProductResponse.prodSelected.palettes[0];
                index = 0;
            }
        }

        nextState.infoPerCat[nextState.categorySelected].skuActiveIndexSelected = index;
        nextState.infoPerCat[nextState.categorySelected].skuActiveSelected = sku.sku;

        const shadeToActivate = nextState.infoPerCat[nextState.categorySelected].skuApplied ==
            nextState.infoPerCat[nextState.categorySelected].skuActiveSelected ?
            nextState.infoPerCat[nextState.categorySelected].shadeApplied : null;

        const setActiveProductResponse = this.setActiveProduct(nextState.products,
            nextState.infoPerCat[nextState.categorySelected].productIdSelected,
            sku.sku,
            shadeToActivate);

        nextState = nextState || {};
        nextState.setActiveProductResponse = setActiveProductResponse;
        nextState.products = setActiveProductResponse.prods;
        nextState.infoPerCat = nextState.infoPerCat;
        nextState.shades = this.setShades(sku, setActiveProductResponse.prodSelected.palettes);
        nextState.showSKUDetail = setActiveProductResponse.skuSelected ? true : false;
        nextState.activeShade = this.setActiveShade(
            setActiveProductResponse.prodSelected,
            setActiveProductResponse.skuSelected,
            setActiveProductResponse.shadeSelected);
        return nextState;
    }

    handleSelectedSKU = (sku, index) => {
        let nextState = this.selectSKU(sku, index);
        nextState = this.selectShade(null, null, nextState);
        this.setState(nextState);

        if (nextState.activeShade) {
            this.props.activeProduct(nextState.activeShade);
        }
    }

    selectShade = (activeShade, index, nextState) => {
        nextState = nextState || this.state;
        if ((!activeShade || typeof index != 'number') && nextState.setActiveProductResponse) {
            if (nextState.setActiveProductResponse.shadeSelected) {
                activeShade = nextState.setActiveProductResponse.shadeSelected;
                index = nextState.setActiveProductResponse.shadeSelectedIndex;
            } else {
                activeShade = nextState.setActiveProductResponse.skuSelected.tones[0];
                index = 0;
            }
        }

        nextState.infoPerCat[nextState.categorySelected].productIdApplied = nextState.infoPerCat[nextState.categorySelected].productIdSelected;
        nextState.infoPerCat[nextState.categorySelected].skuApplied = activeShade.sku;
        nextState.infoPerCat[nextState.categorySelected].shadeApplied = activeShade;
        nextState.infoPerCat[nextState.categorySelected].shadeActiveIndexSelected = index;
        const setActiveProductResponse = this.setActiveProduct(nextState.products,
            nextState.infoPerCat[nextState.categorySelected].productIdApplied,
            nextState.infoPerCat[nextState.categorySelected].skuApplied,
            nextState.infoPerCat[nextState.categorySelected].shadeApplied);

        nextState = nextState || {};
        nextState.products = setActiveProductResponse.prods;
        nextState.infoPerCat = nextState.infoPerCat;
        nextState.activeShade = this.setActiveShade(nextState.selectedProduct, setActiveProductResponse.skuSelected, setActiveProductResponse.shadeSelected);
        return nextState;
    }

    handleSelectedShade = (activeShade, index) => {
        console.log("shade selected")
        if (this.state.infoPerCat[this.state.categorySelected].skuApplied == activeShade.sku &&
            this.state.infoPerCat[this.state.categorySelected].shadeApplied &&
            this.state.infoPerCat[this.state.categorySelected].shadeApplied.hex == activeShade.hex &&
            this.state.infoPerCat[this.state.categorySelected].shadeApplied.finish == activeShade.finish &&
            this.state.infoPerCat[this.state.categorySelected].shadeApplied.coverage == activeShade.coverage) {
            // remove
            gtag('event', 'shade_unselected', {
                'event_label': `sku:${activeShade.sku},hex:${activeShade.hex},coverage:${activeShade.coverage},finish:${activeShade.finish},regions:${activeShade.regions.join('|')}`,
                'event_category': 'shade',
                // 'non_interaction': true
            });
            const nextState = this.removeProducts([this.state.categorySelected]);
            this.setState(nextState);
            activeShade.remove = true;
            this.props.activeProduct(activeShade);
            delete activeShade.remove;
        } else {
            // apply
            gtag('event', 'shade_selected', {
                'event_label': `sku:${activeShade.sku},hex:${activeShade.hex},coverage:${activeShade.coverage},finish:${activeShade.finish},regions:${activeShade.regions.join('|')}`,
                'event_category': 'shade',
                // 'non_interaction': true
            });

            window.utag && utag.link({
                tealium_event: "shade_selected",
                component_type: "productactions",
                glamlab_product_category: this.props.activeCategory, // e.g. foundation
                glamlab_virtual_tryon_mode: localStorage.getItem("mode"), // e.g. photo

                // product attributes
                //
                product_id: [activeShade.hex],
                product_sku: [activeShade.sku],
                product_name: [activeShade.name],
            })

            const nextState = this.selectShade(activeShade, index);

            this.setState(nextState);
            this.props.activeProduct(nextState.activeShade);
        }
    };

    getDummyProducts(totalCount, page, searchAPIPageSize, pagesToAdd) {
        let countAux = totalCount < (page + pagesToAdd) * searchAPIPageSize
            ? totalCount - (page * searchAPIPageSize)
            : searchAPIPageSize;
        let dummyProdArr = [];
        if (countAux > 0) {
            dummyProdArr = new Array(countAux).fill(APIhelper.dummyProduct());
        }
        return dummyProdArr;
    }

    addProductsToArr(products, productsToAdd, fromIndex) {
        let productsAux = products
            .slice(0, fromIndex)
            .concat(productsToAdd);
        if (products.length > productsAux.length) {
            productsAux = productsAux
                .concat(products.slice(productsAux.length));
        }
        return productsAux;
    }

    tryPopulate(page) {
        const infoCategorySelected = this.state.infoPerCat[this.state.categorySelected];
        const nextPageProd = this.state.products[((page) * searchAPIPageSize) - searchAPIPageSize];

        if (nextPageProd &&
            !nextPageProd.productBrand &&
            !infoCategorySelected[`fetching${page}`]) {

            infoCategorySelected[`fetching${page}`] = true;
            this.setState({ infoPerCat: this.state.infoPerCat });

            APIhelper.fetchProducts(page,
                infoCategorySelected.regions,
                infoCategorySelected.seed,
                null,
                this.getSkusToShowFirst(this.state.productDetailToShow, this.state.categorySelected))
                .then(((response) => {
                    let products = this.addProductsToArr(this.state.products, response.data, (page - 1) * searchAPIPageSize);
                    const { prods } = this.setActiveProduct(products,
                        infoCategorySelected.productIdSelected,
                        infoCategorySelected.skuApplied || infoCategorySelected.skuActiveSelected,
                        infoCategorySelected.shadeApplied)
                    // console.log(products.map(d => d.productName));
                    delete infoCategorySelected[`fetching${page}`];
                    let infoPerCat = this.state.infoPerCat;
                    this.setState({ products: prods, infoPerCat: infoPerCat });
                }).bind(this));
        }
    }

    getActiveShade(products, productIdSelected, skuApplied, shadeApplied) {
        const product = products.find(p => p.productId == productIdSelected);
        const palette = product.palettes.find(pal => pal.sku == skuApplied);
        let tone = null;
        if (palette) {
            tone = palette.tones.find(
                t => t.hex == shadeApplied.hex &&
                    t.finish == shadeApplied.finish &&
                    t.coverage == shadeApplied.coverage);
        }
        return { product, palette, tone };
    }

    setActiveProduct(products, productIdSelected, skuApplied, shadeApplied, selectDefault) {
        let prodSelected = null;
        let prodSelectedIndex = null;
        let skuSelected = null;
        let skuSelectedIndex = null;
        let shadeSelected = null;
        let shadeSelectedIndex = null;
        const prods = products.map((p, pi) => {
            if (p.productId == productIdSelected) {
                p.active = true;
                prodSelected = p;
                prodSelectedIndex = pi;
                p.palettes = p.palettes.map((pal, pali) => {
                    if (pal.sku == skuApplied) {
                        pal.active = true;
                        skuSelected = pal;
                        skuSelectedIndex = pali;
                        pal.tones = pal.tones.map((t, ti) => {
                            if (shadeApplied &&
                                t.hex == shadeApplied.hex &&
                                t.finish == shadeApplied.finish &&
                                t.coverage == shadeApplied.coverage) {
                                t.active = true;
                                shadeSelected = t;
                                shadeSelectedIndex = ti;
                            } else {
                                t.active = false;
                            }
                            return t;
                        })
                    } else {
                        pal.active = false;
                        pal.tones = pal.tones.map(t => {
                            t.active = false;
                            return t;
                        })
                    }
                    return pal;
                });
            } else {
                p.active = false;
                if (p.palettes) {
                    p.palettes = p.palettes.map((pal) => {
                        pal.active = false;
                        pal.tones = pal.tones.map(t => {
                            t.active = false;
                            return t;
                        })
                        return pal;
                    });
                }
            }
            return p;
        });
        if (selectDefault && prodSelected) {
            if (!skuSelected) {
                prodSelected.palettes[0].active = true;
                skuSelected = prodSelected.palettes[0];
                skuSelectedIndex = 0;
            }
            if (!shadeSelected) {
                skuSelected.tones[0].active = true;
                shadeSelected = skuSelected.tones[0];
                shadeSelectedIndex = 0;
            }
        }
        return { prods, prodSelected, prodSelectedIndex, skuSelected, skuSelectedIndex, shadeSelected, shadeSelectedIndex };
    }

    getSlideChangeStepProduct(activeIndex) {

        this.state.infoPerCat[this.state.categorySelected].productActiveIndex = activeIndex;
        this.setState({ infoPerCat: this.state.infoPerCat });

        const page = Math.ceil(activeIndex / searchAPIPageSize);
        // console.log(`getSlideChangeStepProduct | page: ${page}`);
        this.tryPopulate(page);
        this.tryPopulate(page + 1);
        this.tryPopulate(page + 2);
        this.tryPopulate(page - 1);
    }

    getSlideChangeStepShade(activeIndex, propName) {
        console.log(`getSlideChangeStepShade: ${this.state.categorySelected} | ${propName} | ${activeIndex}`);
        this.state.infoPerCat[this.state.categorySelected][propName] = activeIndex;
        this.setState({ infoPerCat: this.state.infoPerCat });
    }

    goBackArrow() {

    }

    handleSelectedRegions = (category) => {
        if (category.name === reStyleCategory) {
            return;
        }

        if (this.state.categorySelected !== category.name) {

            let nextState = {
                categorySelected: category.name,
                regions: category.regions,
                infoPerCat: this.state.infoPerCat
            };
            const infoPerCat = nextState.infoPerCat;

            if (!infoPerCat) {
                return;
            }

            if (!infoPerCat[category.name]) {

                infoPerCat[category.name] = {
                    regions: category.regions,
                    productActiveIndex: 0,
                    shadeActiveIndex: 0,
                };
                nextState.infoPerCat = infoPerCat;
            }

            nextState.carouselStepProduct = (infoPerCat[category.name].productActiveIndexSelected ? infoPerCat[category.name].productActiveIndexSelected : infoPerCat[category.name].productActiveIndex) + Math.random();

            nextState.carouselStepSku = (infoPerCat[category.name].skuActiveIndexSelected ? infoPerCat[category.name].skuActiveIndexSelected : infoPerCat[category.name].skuActiveIndex) + Math.random();

            nextState.carouselStepShade = (infoPerCat[category.name].shadeActiveIndexSelected ? infoPerCat[category.name].shadeActiveIndexSelected : infoPerCat[category.name].shadeActiveIndex) + Math.random();

            nextState.page = Math.ceil(nextState.carouselStepProduct / searchAPIPageSize);

            const callPrevPage = nextState.page > 1;

            const callNextPage = true;

            const skusToShowFirst = this.getSkusToShowFirst(this.state.productDetailToShow, category.name);

            let promises = [
                callPrevPage && APIhelper.fetchProducts(nextState.page - 1, nextState.regions, infoPerCat[category.name].seed, null, skusToShowFirst),
                APIhelper.fetchProducts(nextState.page, nextState.regions, infoPerCat[category.name].seed, null, skusToShowFirst),
                callNextPage && APIhelper.fetchProducts(nextState.page + 1, nextState.regions, infoPerCat[category.name].seed, null, skusToShowFirst)
            ];

            Promise.all(promises)
                .then(((responses) => {
                    const page = callPrevPage ? nextState.page - 1 : nextState.page;
                    nextState.products = new Array(page * searchAPIPageSize - searchAPIPageSize)
                        .fill(APIhelper.dummyProduct())
                    for (let q = 0; q < responses.length; q++) {
                        if (responses[q] && responses[q].data && responses[q].data.length > 0) {
                            nextState.products = nextState.products
                                .concat(responses[q].data);
                            infoPerCat[category.name].pagination = responses[q].pagination;
                        }
                    }

                    const totalCount = infoPerCat[category.name].pagination.totalCount;
                    const dummyProdArr = this.getDummyProducts(totalCount, nextState.page + 1, searchAPIPageSize, 100);

                    const productId = infoPerCat[category.name].productIdApplied ?
                        infoPerCat[category.name].productIdApplied : infoPerCat[category.name].productIdSelected ?
                            infoPerCat[category.name].productIdSelected : nextState.products[0].productId;
                    const skuApplied = infoPerCat[category.name].skuApplied ?
                        infoPerCat[category.name].skuApplied : infoPerCat[category.name].skuActiveSelected;
                    // const shadeApplied = infoPerCat[category.name].shadeApplied;

                    nextState.products = this.addProductsToArr(nextState.products, dummyProdArr, (nextState.page + 1) * searchAPIPageSize);

                    //reset values
                    nextState.selectedProduct = {};
                    nextState.activeShade = null;
                    nextState.skus = [];
                    nextState.shades = [];
                    nextState.hideProdFamily = false;
                    nextState.showSKUDetail = false;

                    if (productId) {
                        const prod = nextState.products.find(p => p.productId == productId);
                        if (prod) {
                            nextState = this.selectProduct(prod, nextState);
                            nextState = this.selectSKU(null, null, nextState);
                            // nextState = this.selectShade(null, null, nextState);
                        }
                    }

                    this.setState(nextState);
                    if (nextState.activeShade) {
                        this.props.activeProduct(nextState.activeShade);
                    }

                }).bind(this));
        };
    };

    render() {

        const displayProducts = !this.props.mobile || this.props.mobile && !this.state.hideProdFamily ? { display: 'block' } : { visibility: 'hidden', height: '0px' };

        const displayPalettes = (this.state.shades.length > 0 || this.state.skus.length > 0) &&
            (!this.props.mobile || this.props.mobile && this.state.hideProdFamily) ? 'block' : 'none';

        return (
            <div id="productsComp"
                style={{ display: this.props.show ? 'flex' : 'none' }}
                className={styles.prodWrap}
                ref={this.productsComp}
            >
                <div id="prodsCar" style={displayProducts}
                    className={classnames(styles.divideLineProd, styles.divideLineCarousel)}>
                    <Carousel
                        hideNavigation={this.props.mobile}
                        navigationClass={'prodFamNav'}
                        slidesPerView={{ mobile: 'auto', desk: 'auto' }}
                        spaceBetween={{ mobile: 5, desk: 10 }}
                        step={this.state.carouselStepProduct}
                        // getCarouselCurrentStep={this.getCarouselCurrentStep}
                        getSlideChangeStep={this.getSlideChangeStepProduct}
                        products={true}
                    >
                        {
                            this.state.products.map((product, index) =>
                                <ProductSKUCard key={"-card-" + index}
                                    onClick={() => { this.handleSelectedProduct(product) }}
                                    product={product}
                                    page={this.handlePagination} />
                            )
                        }
                    </Carousel>
                </div>

                <div id="firstSec" style={{ display: displayPalettes }}
                    className={classnames(styles.divideLine, styles.divideLineShades)}>
                    <div className={styles.shadeSection}>
                        <div id="shadedetail" style={{ display: this.props.mobile && this.state.showSKUDetail ? 'flex' : 'none' }}
                            className={styles.prodImg}>
                            <div className={styles.nav}>
                                <Arrow className={styles.arrow} onClick={() => {
                                    this.props.menuHeightChanged(this.productsComp.current.offsetHeight);
                                    this.setState({ hideProdFamily: false, showSKUDetail: false });
                                }} />
                                <div className={styles.info}>
                                    {
                                        this.state.activeShade &&
                                        <Info link={`https://www.ulta.com/p?productId=${this.state.activeShade.productUltaId}&sku=${this.state.activeShade.sku}`} />
                                    }
                                </div>
                            </div>

                            {
                                this.state.activeShade &&
                                <CardImg src={this.state.activeShade.paletteImage} />
                            }

                        </div>
                        <div id="mobileProdDetailAndCarousel" className={classnames(styles.shadeDetail, !this.state.showSKUDetail ? styles.shadeDetailLarge : '')}>
                            {
                                (this.props.mobile && this.state.activeShade && this.state.showSKUDetail) &&
                                <ProductDetail
                                    addToBag={this.props.addToBag}
                                    addedToBag={this.props.addedToBag}
                                    activeShade={this.state.activeShade}
                                    activeCategory={this.props.activeCategory} />
                            }
                            {
                                (this.props.mobile && !this.state.showSKUDetail) &&
                                <Arrow className={styles.arrow}
                                    onClick={() => {
                                        this.props.menuHeightChanged(this.productsComp.current.offsetHeight);
                                        this.setState({ hideProdFamily: false, showSKUDetail: false });
                                    }} />
                            }

                            {
                                (this.props.mobile && this.state.shades && this.state.shades.length > 0) &&

                                <Carousel
                                    className={!this.state.showSKUDetail ? styles.largeCarousel : ''}
                                    hideNavigation={this.props.mobile}
                                    navigationClass={'shadesNav'}
                                    slidesPerView={{ mobile: 'auto', desk: 'auto' }}
                                    spaceBetween={{ mobile: 5, desk: 10 }}
                                    step={this.state.carouselStepShade}
                                    // getCarouselCurrentStep={this.getCarouselCurrentStepShade}
                                    getSlideChangeStep={(activeIndex) => { this.getSlideChangeStepShade(activeIndex, 'shadeActiveIndex') }}
                                >
                                    {
                                        this.state.shades.map((shade, index) =>
                                            <Shade key={"shade-" + index}
                                                shade={shade}
                                                onClick={() => { this.handleSelectedShade(shade, index) }} />
                                        )
                                    }
                                </Carousel>
                            }

                            {
                                (!this.props.mobile && this.state.skus.length > 0) &&
                                <Carousel
                                    className={styles.largeCarousel}
                                    hideNavigation={this.props.mobile}
                                    navigationClass={'shadesNav'}
                                    slidesPerView={{ mobile: 'auto', desk: 'auto' }}
                                    spaceBetween={{ mobile: 5, desk: 10 }}
                                    step={this.state.carouselStepSku}
                                    // getCarouselCurrentStep={this.getCarouselCurrentStepShade}
                                    getSlideChangeStep={(activeIndex) => { this.getSlideChangeStepShade(activeIndex, 'skuActiveIndex') }}
                                >
                                    {
                                        this.state.skus.map((sku, index) =>
                                            <SKU key={"sku-" + index}
                                                sku={sku}
                                                onClick={() => { this.handleSelectedSKU(sku, index) }} />
                                        )
                                    }
                                </Carousel>
                            }

                        </div>

                    </div>
                    {
                        (this.props.mobile && this.state.skus.length > 0) &&
                        <Carousel
                            className={classnames(styles.largeCarousel2)}
                            hideNavigation={this.props.mobile}
                            navigationClass={'shadesNav'}
                            slidesPerView={{ mobile: 'auto', desk: 'auto' }}
                            spaceBetween={{ mobile: 5, desk: 10 }}
                            step={this.state.carouselStepSku}
                            // getCarouselCurrentStep={this.getCarouselCurrentStepShade}
                            getSlideChangeStep={(activeIndex) => { this.getSlideChangeStepShade(activeIndex, 'skuActiveIndex') }}
                        >
                            {
                                this.state.skus.map((sku, index) =>
                                    <SKU key={"sku-" + index}
                                        sku={sku}
                                        onClick={() => { this.handleSelectedSKU(sku, index) }} />
                                )
                            }
                        </Carousel>
                    }
                </div>
                {
                    (!this.props.mobile && this.state.shades && this.state.shades.length > 0) &&

                    <div
                        className={classnames(styles.divideLine, styles.divideLineShades)}
                        style={this.state.skus.length == 0 ? { marginTop: '-15px' } : {}}>

                        <Carousel
                            className={!this.state.showSKUDetail ? styles.largeCarousel : ''}
                            hideNavigation={this.props.mobile}
                            navigationClass={'shadesNav'}
                            slidesPerView={{ mobile: 'auto', desk: 'auto' }}
                            spaceBetween={{ mobile: 5, desk: 10 }}
                            step={this.state.carouselStepShade}
                            // getCarouselCurrentStep={this.getCarouselCurrentStepShade}
                            getSlideChangeStep={(activeIndex) => { this.getSlideChangeStepShade(activeIndex, 'shadeActiveIndex') }}
                        >
                            {
                                this.state.shades.map((shade, index) =>
                                    <Shade key={"shade-" + index}
                                        shade={shade}
                                        onClick={() => { this.handleSelectedShade(shade, index) }} />
                                )
                            }
                        </Carousel>
                    </div>
                }

                {
                    (!this.props.mobile && this.state.activeShade) &&
                    <ProductDetail
                        addToBag={this.props.addToBag}
                        addedToBag={this.props.addedToBag}
                        activeShade={this.state.activeShade}
                        activeCategory={this.props.activeCategory} />
                }

            </div>
        )
    };
};